import React, { createContext, useContext, useReducer } from 'react';
import reducer from './reducer';

export const initialState = {
  salesState: '',
  salesOrder: [],
  noMoreSalesOrder: false,
  salesOrderFilters: {},
  salesOrderNotifications: [],
  readSalesOrderNotifications: [],
}

export const SalesOrderStateContext = createContext();
export const SalesOrderDispatchContext = createContext();

function SalesOrderContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <SalesOrderStateContext.Provider value={state}>
      <SalesOrderDispatchContext.Provider value={dispatch}>
        {children}
      </SalesOrderDispatchContext.Provider>
    </SalesOrderStateContext.Provider>
  )
}

function useSalesOrderDispatch() {
  const context = useContext(SalesOrderDispatchContext)
  if (context === undefined) {
    throw new Error('useSalesOrderDispatch must be used within a SalesOrderProvider')
  }
  return context
}

function useSalesOrderState() {
  const context = useContext(SalesOrderStateContext)
  if (context === undefined) {
    throw new Error('useSalesOrderState must be used within a SalesOrderProvider')
  }
  return context
}

export { SalesOrderContext, useSalesOrderDispatch, useSalesOrderState };